import { createSelector } from 'reselect';
import { getLocaleUrlPath } from 'utils';

var getSeo = function getSeo(state) {
  return state.seo;
};

export var makeGetSeoUrl = function makeGetSeoUrl() {
  return createSelector(function (state, props) {
    return props.location.pathname;
  }, function (state, props) {
    return props.locale || props.intl.locale;
  }, function (pathname, locale) {
    return "".concat(getLocaleUrlPath(locale)).concat(process.env.APP_ROUTER_BASENAME).concat(pathname);
  });
};
export var makeGetSeoByUrl = function makeGetSeoByUrl() {
  var getSeoUrl = makeGetSeoUrl();
  return createSelector(getSeo, getSeoUrl, function (seo, seoUrl) {
    return seo[seoUrl] || {};
  });
};
export var makeGetSeoMeta = function makeGetSeoMeta() {
  return createSelector(makeGetSeoByUrl(), function (seo) {
    return seo.meta || {};
  });
};
export var getSeoMeta = makeGetSeoMeta();
export var makeGetSeoLinksBlocks = function makeGetSeoLinksBlocks() {
  var getSeoByUrl = makeGetSeoByUrl();
  return createSelector(getSeoByUrl, function (seo) {
    return seo.linksBlocks || {};
  });
};
export var makeGetSeoLinksBlocksItems = function makeGetSeoLinksBlocksItems() {
  var getSeoLinksBlocks = makeGetSeoLinksBlocks();
  return createSelector(getSeoLinksBlocks, function (seoLinksBlocks) {
    return seoLinksBlocks.items || [];
  });
};
export var makeGetSeoTextsBlocks = function makeGetSeoTextsBlocks() {
  var getSeoByUrl = makeGetSeoByUrl();
  return createSelector(getSeoByUrl, function (seo) {
    return seo.texts || {};
  });
};
export var makeGetSeoTextsBlocksItems = function makeGetSeoTextsBlocksItems() {
  var getSeoTextsBlocks = makeGetSeoTextsBlocks();
  return createSelector(getSeoTextsBlocks, function (seoTextsBlocks) {
    return seoTextsBlocks.items || [];
  });
};
var getSeoByUrl = makeGetSeoByUrl();
export var makeGetBreadcrumbs = function makeGetBreadcrumbs() {
  return createSelector(getSeoByUrl, function (seo) {
    return seo.breadcrumbs || {};
  });
};
export var getBreadcrumbs = makeGetBreadcrumbs();